import { IAdvertiserPublisherRelation } from 'src/common/models/advertiserPublisherRelation';

export default function isUnread(relation: IAdvertiserPublisherRelation) {
  return !relation.archive && relation.notification_count > 0;
}
